import type {
  GroupSchemaType,
  IAIPromptGroup,
  ITextReplaceRule,
  Modification,
} from '@carboncopyco/types';
import constate from 'constate';
import { useState } from 'react';
import type { ITextReplaceResult, onAiRequest } from './types';

type Rule = Modification<GroupSchemaType.aiPromptGroup>;
export type CreateAiRequest = Pick<IAIPromptGroup, 'name' | 'prompt'> & {
  dataList: ITextReplaceResult[];
  modification?: Rule;
};

interface AiManagerContextProviderProps {
  onAiRequest: onAiRequest;
  pageUrl: string;
  innerHtml: string;
  getInnerHtml: () => void;
  getImage?: () => Promise<string>;
  createAiRequest({
    name,
    prompt,
    dataList,
    modification,
  }: CreateAiRequest): Promise<void>;
  getAllSubGroupModifications: (groupId: string) => Modification[];
  textReplaceRules: ITextReplaceRule[];
  checkIfTheReplaceTextRuleExists: (oldValue: string) => boolean;
}
function useAIManager({
  onAiRequest,
  innerHtml,
  getInnerHtml,
  getImage,
  createAiRequest,
  getAllSubGroupModifications,
  pageUrl,
  checkIfTheReplaceTextRuleExists,
  textReplaceRules,
}: AiManagerContextProviderProps) {
  const [editRule, setEditRule] = useState<Rule | undefined>();

  return {
    onAiRequest,
    innerHtml,
    getInnerHtml,
    getImage,
    createAiRequest,
    getAllSubGroupModifications,
    pageUrl,
    editRule,
    setEditRule,
    checkIfTheReplaceTextRuleExists,
    textReplaceRules,
  };
}

export const [AIManagerProvider, useAIManagerContext] = constate(useAIManager);
